import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, TextInput } from '@carbon/react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { InlineError } from './states';
import { khopTenXoa } from './xoaIdKhop';

// Xóa ID (owner 2026-10-02): the founder only; the API refuses every other role. The account is closed (no login,
// out of the player list, username free again); bets, ledger and reports keep its rows.
export function useCanDeleteId(): boolean {
  return useAuth().me?.role === 'founder';
}

export function XoaIdDialog({ player, onClose, onDone }: {
  player: { id: number; name: string } | null; onClose: () => void; onDone?: () => void;
}) {
  const qc = useQueryClient();
  const [typed, setTyped] = useState('');
  const m = useMutation({
    mutationFn: (id: number) => api.post(`/api/admin/users/${id}/delete`),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['users'] }); setTyped(''); onClose(); onDone?.(); },
  });
  const close = () => { m.reset(); setTyped(''); onClose(); };
  const ok = !!player && khopTenXoa(typed, player.name);
  const sai = typed.trim() !== '' && !ok;
  return (
    <Modal open={!!player} danger modalHeading={`Xóa ID ${player?.name ?? ''}?`} primaryButtonText="Xóa ID" secondaryButtonText="Hủy"
      primaryButtonDisabled={!ok || m.isPending} onRequestClose={close} onRequestSubmit={() => { if (player && ok) m.mutate(player.id); }}>
      <div className="stack">
        <p>Tài khoản bị đóng hẳn: không đăng nhập được, không còn trong danh sách người chơi, tên đăng nhập dùng lại được cho người khác. Lịch sử cược, giao dịch và báo cáo giữ nguyên.</p>
        <p>Chỉ xóa được khi số dư bằng 0, không còn lệnh nạp / rút hay cược đang chờ và tài khoản không phải đại lý.</p>
        <TextInput id="xoa-id-xac-nhan" labelText={`Gõ lại tên đăng nhập "${player?.name ?? ''}" để xác nhận`} value={typed}
          autoComplete="off" autoCapitalize="none" autoCorrect="off" spellCheck={false}
          invalid={sai} invalidText="Tên đăng nhập chưa khớp" onChange={(e) => setTyped(e.target.value)} />
        <InlineError error={m.error} />
      </div>
    </Modal>
  );
}
